// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import DocumentsV2 from '../components/Frontend/AccountDetails/Documents/DocumentsV2';

export const documentsRoutes = (
  <>
    <Route path="account_details/documents" element={<MainLayout />}>
      <Route index element={<DocumentsV2 />} />
    </Route>
  </>
);
